<template>
  <div class="modal-parent">
    <loading
      v-model:active="loading"
      :can-cancel="true"
      :is-full-page="true"
      color="#669933"
      loader="spinner"
    />
    <section class="header">
      <div class="" style="margin: 0 auto; width: 96%">
        <div class="header-content">
          <div class="section-1">
            <h5 class="modal-caption">Add Loader's Record</h5>
          </div>

          <div class="section-2">
            <div class="logo-container">
              <img src="../../../../assets/releaf-logo.png" alt="" />
            </div>

            <div class="icon-container">
              <div
                class="close-container"
                style="cursor: pointer"
                @click="closeModal"
              >
                <img src="../../../../assets/x-icon.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- border -->
    <div class="border"></div>

    <!-- Form section -->
    <section class="form-section">
      <form class="form">
        <DateField
          placeholder="Date of Payment"
          @onInputChange="handleInputChange"
          fieldName="date"
          :inputValue="loaderForm?.date"
        />

        <SelectDropdown
          :options="['Salary', 'Incentive', 'Food']"
          class="select"
          dropdownTitle="Payment Type"
          fieldName="paymentType"
          @onSelect="handleSelect"
          :inputValue="loaderForm?.paymentType"
        />

        <NumberInput
          placeholder="Number Of Loaders"
          @onInputChange="handleInputChange"
          fieldName="numberOfLoaders"
          :inputValue="loaderForm?.numberOfLoaders"
        />

        <NumberInput
          placeholder="Amount paid"
          @onInputChange="handleInputChange"
          fieldName="amountPaid"
          :inputValue="loaderForm?.amountPaid"
        />
        <Dropdown
          :options="vehicles"
          class="select"
          dropdownTitle="Vehicle"
          fieldName="vehicle"
          fieldValue="name"
          @onSelect="handleSelect"
          :inputValue="loaderForm?.name"
        />
      </form>
    </section>

    <div class="button-container">
      <GreenButton width="12rem" label="Submit" @click="addLoaderRecord" />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { createToast } from "mosha-vue-toastify";
import DateField from "../../../../components/form-inputs/date-input/DateField.vue";
import GreenButton from "../../../../components/buttons/green-button/GreenButton.vue";
import SelectDropdown from "../../../../components/form-inputs/select-dropdown/SelectDropdown.vue";
import NumberInput from "../../../../components/form-inputs/number-input/NumberInput.vue";
import Dropdown from "../../../../components/form-inputs/select-dropdown/Dropdown.vue";

export default {
  name: "AddLoaderModal",

  components: {
    GreenButton,
    DateField,
    SelectDropdown,
    NumberInput,
    Dropdown,
    Loading,
  },

  data() {
    return {
      loaderForm: {
        date: "",
        paymentType: "",
        numberOfLoaders: "",
        amountPaid: "",
        vehicle: "",
      },
      loading: false,
      vehicles: [],
      isRefresh: false,
    };
  },

  mounted() {
    this.fetchVehicles();
  },

  methods: {
    closeModal() {
      this.$emit("onCloseModal", false);
    },

    async fetchVehicles(page = 1) {
      const { assets } = await this.$store.dispatch(
        "vehicleManagement/fetchVehicles",
        {
          page,
        }
      );

      this.vehicles = assets;
    },

    handleSelect(obj) {
      this.loaderForm = {
        ...this.loaderForm,
        ...obj,
      };
    },

    handleInputChange(obj) {
      this.loaderForm = {
        ...this.loaderForm,
        ...obj,
      };
    },

    async addLoaderRecord() {
      const { date, paymentType, numberOfLoaders, amountPaid, vehicle } =
        this.loaderForm;
      if (!date || !paymentType || !numberOfLoaders || !amountPaid) {
        return createToast("All fields are required!", {
          type: "danger",
          timeout: 2000,
          position: "top-left",
        });
      }

      const payload = {
        date,
        paymentType,
        noOfLoaders: numberOfLoaders,
        totalAmount: amountPaid,
        vehicle,
      };

      try {
        this.loading = true;
        const record = await this.$store.dispatch(
          "loadersSalaryCosts/addNewCosts", // need to update api
          payload
        );

        if (record) {
          this.loading = false;
          createToast("Loader's record added successfully!", {
            type: "success",
            timeout: 3000,
            position: "top-right",
            onClose: () => {
              this.$store.dispatch("overhead/setRefreshStatus", true);
              this.closeModal();
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.modal-parent {
  background-color: white;
  height: 100%;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px;
  /* border: 1px solid #000; */
}

.section-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
  width: 40%;
}

p {
  color: #232a34;
  font-weight: 900;
  align-self: center;
  font-size: 0.77rem;
  margin-top: 7px;
}

.section-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
  width: 55%;
}

.modal-caption {
  color: #232a34;
  font-weight: 700;
}

.logo-container {
  background-color: #232a34;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid green;
}

.logo-container img {
  width: 30px;
  height: auto;
}

.icon-container {
  display: flex;
  justify-content: space-between;
}

.close-container {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: #dcdbdb;
}

.close-container:hover {
  background: #e8e8e8;
}

.border {
  margin-top: 10px;
  border-bottom: 1px solid #b3b3b3;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 4% auto 2% auto;
}
</style>
